import React from "react";
import "./Crestabanner.scss";
import Comingsoon from "../../Media/Uki_Cresta_Desktop.png";
import Soon from "../../Media/Uki_Cresta_Mobile.png";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6281311110717&text=Halo%20Uki,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Harapan%20Indah%20(Cresta%207)%20https://kota-harapan-indah.id//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="Cresta" className="container-cresta">
      <div className="bellefont">
        <h1>New Launching Kota Harapan Indah</h1>
        <h2>Cluster Cresta</h2>
      </div>
      <div className="maps-lokasi">
        <img className="img-Desktop" src={Comingsoon} alt="maps" />
        <img className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
